<div class="modalAdd">
    <div class="add_another_waste_modal waste_popup_modal add_view_reject_popup_modal">
        <div class="">
            <div class="modal-content">
                <div class="modal-header">
                    <h3 class="modal-title" id="title">Rejected Request<span *ngIf="rejectedNotificationData.length > 1">s</span> ({{rejectedNotificationData.length}})</h3>
                    <img style="margin-top:2px" src="../../../../assets/images/close_icon.svg" class="close" alt="close botton" (click)="closeDialog(false)">                    
                </div>
            </div>
            <div class="waste_modal_content cf nopadding table-responsive" style="background: white;">
                <table class="table_view_reject_modal" aria-describedby="">
                    <thead>
                        <tr>
                            <th id="">Calibration Time</th>
                            <th id="">Product Name</th>
                            <th id="">Request Type</th>
                            <th id="">Reject Reason</th>
                            <th id="">Rejected Time</th>                          
                            <th id="select-all-checkbox">
                                <mat-checkbox                                  
                                    id="selectAll"
                                    [checked]="selectAllNotification"
                                    (change)="clearAll($event.checked)">                                                                                    
                                </mat-checkbox>
                            </th>
                        </tr>
                    </thead>
                    <tbody> 
                        <tr *ngFor="let notificationObj of rejectedNotificationData;let i = index;">
                            <td>{{notificationObj.calibrationTime}}</td>
                            <td>{{notificationObj.productName}}</td>
                            <td>{{notificationObj.orderType}}</td>
                            <td>{{notificationObj.rejectResonDesc}}</td>
                            <td>{{notificationObj.rejectTime}}</td>
                            <td>
                                <mat-checkbox
                                    [checked]="notificationObj.acknowledged"                                  
                                    [id]="'msg' + i"
                                    (change)="clear(notificationObj,$event.checked)">                                
                               </mat-checkbox>                               
                            </td>                            
                        </tr>
                    </tbody>
                </table>   
                <div>
                    <p class="add_view_reject_popup_p">* Your Nuctrac procedure change is updated. The pharmacy rejected
                        the order modification. <u>Please contact the pharmacy for more information </u> </p>
                </div> 
                <div class="footer-btn-div">                    
                    <button type="button" class="button secondary" (click)="closeDialog(false)">
                    CLOSE
                    </button>
                    <button type="button" class="button secondary clear-selected-btn" 
                    [ngClass]="{disabled:disableClearSelectedBtn}"
                    (click)="saveRejectedNotification(true)">
                    CLEAR SELECTED
                    </button>                  
                </div>
            </div>

        </div>

    </div>
</div>